import * as eff from 'redux-saga/effects';
import createActionCreators from 'redux-resource-action-creators';
import {
  actionTypes,
  resourceActionTypes,
} from '../actions';
import {
  throwError,
} from './helpers';
import api from '../api';

export default function* conversationFlow() {
  function* fetchUnreadCount() {
    try {
      const count = yield eff.call(
        api.getConversations,
        {
          type: 'count',
        },
      );

      yield eff.put({
        type: resourceActionTypes.UPDATE_RESOURCES,
        meta: {
          conversations: {
            unread: {
              count,
            },
          },
        },
      });
    } catch (e) {
      yield eff.call(throwError, e);
    }
  }

  function* fetchConversationList({ listName, callbacks }) {
    const actions = createActionCreators('read', {
      resourceType: 'conversations',
      list: listName || 'all',
      requestKey: 'fetchConversationList',
    });

    yield eff.put(
      actions.pending(),
    );

    try {
      const conversations = yield eff.call(
        api.getConversations,
      );

      callbacks?.onSuccess?.(conversations);

      yield eff.put(actions.succeeded({
        resources: conversations,
      }));
    } catch (e) {
      callbacks?.onError?.(e);
      yield eff.put(actions.failed({
        resources: [],
      }));

      yield eff.call(throwError, e);
    }
  }

  function* fetchUnreadCategories({ id }) {
    const actions = createActionCreators('update', {
      resourceType: 'conversations',
      requestKey: 'fetchUnreadCategories',
    });

    yield eff.put(
      actions.pending(),
    );

    try {
      const unreadCategories = yield eff.call(
        api.getConversations,
        {
          type: `${id}/unread_categories`,
        },
      );

      const hasUnread = [1, 2, 3].some(
        key => unreadCategories[key].length > 0,
      );

      yield eff.put(actions.succeeded({
        resources: [{
          id: Number(id),
          unreadCategories,
          has_unread_messages: hasUnread,
        }],
      }));
    } catch (e) {
      yield eff.put(actions.failed({
        resources: [],
      }));

      yield eff.call(throwError, e);
    }
  }

  function* fetchMessages({ id, qs }) {
    const actions = createActionCreators('read', {
      resourceType: 'messages',
      list: id,
      requestKey: 'fetchMessages',
    });

    yield eff.put(
      actions.pending(),
    );

    try {
      const messages = yield eff.call(
        api.getConversations,
        {
          qs,
          type: id,
        },
      );

      yield eff.fork(
        fetchUnreadCategories,
        {
          id,
        },
      );

      yield eff.put(actions.succeeded({
        resources: messages,
      }));
    } catch (e) {
      yield eff.put(actions.failed({
        resources: [],
      }));

      yield eff.call(throwError, e);
    }
  }

  function* markReadMessages({ ids, conversationId }) {
    const actions = createActionCreators('update', {
      resourceType: 'messages',
      requestKey: 'markReadMessages',
    });

    yield eff.put(
      actions.pending(),
    );

    try {
      yield eff.all(
        ids.map(
          id => eff.call(
            api.markMessageAsRead,
            {
              id,
              body: {
                status: true,
              },
            },
          ),
        ),
      );

      if (conversationId) {
        yield eff.fork(
          fetchUnreadCategories,
          {
            id: conversationId,
          },
        );
      }
      yield eff.fork(fetchUnreadCount);

      yield eff.put(actions.succeeded({
        resources: ids.map(
          id => ({
            id,
            is_read: true,
          }),
        ),
      }));
    } catch (e) {
      yield eff.put(actions.failed({
        resources: [],
      }));

      yield eff.call(throwError, e);
    }
  }

  yield eff.takeEvery(actionTypes.REQUEST_MESSAGES, fetchMessages);
  yield eff.takeEvery(actionTypes.REQUEST_UNREAD_COUNT, fetchUnreadCount);
  yield eff.takeEvery(actionTypes.REQUEST_CONVERSATION_LIST, fetchConversationList);
  yield eff.takeEvery(actionTypes.REQUEST_UNREAD_CATEGORIES, fetchUnreadCategories);
  yield eff.takeEvery(actionTypes.REQUEST_MARK_READ_MESSAGES, markReadMessages);
}
